import './keywords.css';

export const colors = {
    diamondGroup: '#abecf7',
    roleGroup: 'rgb(255, 145, 0, 0.445)'
}

export const keywords = {
    diamond: '<span class="keyword diamondText">diamant(s)</span>',
    role: '<span class="keyword roleText">rôle</span>',
    GodFather: '<span class="keyword rl_godfather">Parrain</span>',
    FBI_Agent: '<span class="keyword rl_fbi">FBI</span>',
    Faithfull: '<span class="keyword rl_faithfull">Fidèle</span>',
    Driver: '<span class="keyword rl_driver">Chauffeur</span>',
    Thief: '<span class="keyword rl_thief">Voleur</span>',
    Street_Child: '<span class="keyword rl_street_child">Enfant de la rue</span>',
    player: (name)=>`<span class="keyword playerKey">${name}</span>`
}

export function stylizeKeyword(msg, players, localPlayer){
    var result = msg;
    while(result?.includes('[')){
        const keycode = result.substring(result.indexOf('[')+1, result.indexOf(']'));
        result = result.replace(`[${keycode}]`, keywords[keycode]);
    }

    while(result?.includes('player=')){
        const playerName = result.substring(result.indexOf('player=')+1, result.indexOf(';')).split('=')[1];
        result = result.replace(`player=${playerName};`, keywords.player(playerName));
    }

    while(result?.includes('{')){
        const side = result.substring(result.indexOf('{')+1, result.indexOf('}'));
        const lpIndex = players.map(p=>p.socketId).indexOf(localPlayer.socketId)
        var i = lpIndex + (side == 'right' ? 1 : -1);

        if(i >= players.length){
            i = 0;
        }
        if(i < 0){
            i = players.length - 1;
        }

        result = result.replace(`{${side}}`, 
                                `${side == 'right' ? 'droite' : 'gauche'} (${keywords.player(players[i].name)})`);
    }

    return result;
}